export const FIELDS = {
  ID: 'id',
  LINE_NUM: 'lineNum',
  VENDOR_RMAID: 'vendorRmaId',
  RMALINE_ID: 'rmaLineId',
  RMADATE: 'rmaDate',
  INVENTORY_ID: 'inventoryId',
  STATUS_ID: 'statusId',
  STATUS_NAME: 'statusName',
  COMPANY_ID: 'companyId',
  COMPANY_NAME: 'companyName',
  CONTACT_ID: 'contactId',
  CONTACT_NAME: 'contactName',
  SHIP_FROM_ADDRESS: 'shipFromAddress',
  SHIP_TO_ADDRESS: 'shipToAddress',
  ACTION_ID: 'actionId',
  ACTION_NAME: 'actionName',
  TERMS_ID: 'termsId',
  TERMS_NAME: 'termsName',
  SALES_REP_USER_ID: 'salesRepUserId',
  SALES_PERSON_USER_FULL_NAME: 'salesPersonUserFullName',
  SHIPPING_PROVIDER_ID: 'shippingProviderId',
  SHIPPING_PROVIDER_NAME: 'shippingProviderName',
  SHIPPING_METHOD_ID: 'shippingMethodId',
  SHIPPING_METHOD_NAME: 'shippingMethodName',
  EXPR1: 'expr1',
  VENDOR_RMANUMBER: 'vendorRmaNumber',
  DATE_AUTHORIZED: 'dateAuthorized',
  ACCOUNT_NO: 'accountNo',
  IS_TAXABLE: 'isTaxable',
  TAX_RATE: 'taxRate',
  TAX: 'tax',
  SUB_TOTAL: 'subTotal',
  TOTAL_CHARGES: 'totalCharges',
  TOTAL: 'total',
  PART_ID: 'partId',
  PART_NUMBER: 'partNumber',
  INTERNAL_PN: 'internalPn',
  NSNNUMBER: 'nsnNumber',
  ALT_NUMBER: 'altNumber',
  SKU: 'sku',
  HARMONIZED_CODE: 'harmonizedCode',
  MANUFACTURER_ID: 'manufacturerId',
  MFG_NAME: 'mfgName',
  ALT_MANUFACTURER_ID: 'altManufacturerId',
  ALT_MFR: 'altMfr',
  INVENTORY_CLASS_ID: 'inventoryClassId',
  CLASS_NAME: 'className',
  INVENTORY_CATEGORY_ID: 'inventoryCategoryId',
  CATEGORY_NAME: 'categoryName',
  UO_MID: 'uoMId',
  UOM: 'uom',
  PACKAGE_ID: 'packageId',
  PACKAGE: 'package',
  PIECE_PER_PKG: 'piecePerPkg',
  LEAD_FREE: 'leadFree',
  DESCRIPTION: 'description',
  TEMP_RATING: 'tempRating',
  PART_COMMENTS: 'partComments',
  WAREHOUSE_ID: 'warehouseId',
  WAREHOUSE_NAME: 'warehouseName',
  LOCATION: 'location',
  RETURN_REASON_ID: 'returnReasonId',
  RETURN_REASON_NAME: 'returnReasonName',
  DATE_CODE: 'dateCode',
  COUNTRY_OF_ORIGIN_ID: 'countryOfOriginId',
  COUNTRY_OF_ORIGIN_NAME: 'countryOfOriginName',
  ORDERED: 'ordered',
  RETURNED: 'returned',
  COST: 'cost',
  CORE_CHARGE: 'coreCharge',
  COMMENTS: 'comments',
  JOB_NUMBER: 'jobNumber',
  PURCHASE_ORDER_ID: 'purchaseOrderId',
  POLINE_ID: 'poLineId',
  FOR_REPLACEMENT: 'forReplacement',
  CURRENCY_TYPE_ID: 'currencyTypeId',
  CURRENCY_TYPE_NAME: 'currencyTypeName',
  CURRENCY_SYMBOL: 'currencySymbol',
  EXCHANGE_RATE: 'exchangeRate',
  LINE_TOTAL: 'lineTotal',
  WARRANTY_ID: 'warrantyId',
  END_LINE_USAGE: 'endLineUsage',
  VENDOR_DATE: 'vendorDate',
  LOT_CODE: 'lotCode',
  CONDITION_ID: 'conditionId',
  BIN_NUMBER: 'binNumber',
  CUSTOMER_PN: 'customerPn',
  TARIFF_CODE: 'tariffCode',
  REVISION: 'revision',
  ORIGIN: 'origin',
  SPECS: 'specs',
  LINE_TYPE: 'lineType',
  QTY_BIN: 'qtyBin',
  TESTED: 'tested',
  MODEL: 'model',
  PMANUMBER: 'pmaNumber',
  CAGE_CODE: 'cageCode',
  EUC__REQUIRED: 'eucRequired',
  REPLACED_BY_PN: 'replacedByPn',
  APPROVAL_BASIS: 'approvalBasis',
  CREATED_BY_USER_ID: 'createdByUserId',
  CREATED_BY_USER: 'createdByUser',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  MODIFIED_BY_USER: 'modifiedByUser',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',};